/* eslint-disable eslint-comments/require-description */
/* eslint-disable no-constant-binary-expression */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
"use client";

import jwtDecode from "jwt-decode";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";

export const useCheckAuthAndRedirect = ({
	location,
	redirect,
	login,
	disabled,
}: {
	location: string;
	redirect?: string;
	login?: string;
	disabled?: boolean;
}) => {
	const router = useRouter();
	const [isChecking, setIsChecking] = useState(true);

	useEffect(() => {
		if (disabled) {
			setIsChecking(false);
			return;
		}

		if (typeof window === "undefined") {
			setIsChecking(false);
			return;
		}

		const token: string | undefined = JSON.parse(
			localStorage.getItem("auth/user") || "{}"
		)?.credentials;

		if (token && token !== "undefined") {
			try {
				const decoded = jwtDecode<{ exp?: number }>(token);
				const isExpired =
					decoded?.exp !== undefined && decoded.exp * 1000 <= Date.now();
				if (isExpired) {
					localStorage.setItem("auth/user", JSON.stringify(null));
					if (location === "dashboard" || location === redirect) {
						const currentPath = window.location.pathname + window.location.search;
						localStorage.setItem("auth/redirect", currentPath);
						router.push(login ?? "/");
						return;
					}
					setIsChecking(false);
					return;
				}
				if (location === "login" && redirect) {
					router.push(`/${redirect}`);
					return;
				}
				setIsChecking(false);
			} catch (error) {
				// If the token isn't a JWT, treat it as a valid session
				if (location === "login" && redirect) {
					router.push(`/${redirect}`);
					return;
				}
				setIsChecking(false);
			}
		} else if (location === "dashboard" || location === redirect) {
			// User not authenticated, trying to access protected route
			// Store current URL for redirect after login
			const currentPath = window.location.pathname + window.location.search;
			localStorage.setItem("auth/redirect", currentPath);
			router.push(login ?? "/");
		} else {
			setIsChecking(false);
		}
	}, [disabled, location, redirect, login, router]);

	return { isChecking };
};
